export default function($) {

  if( !isOverflown( $('.js-cat-description') ) ) {
    $('.js-trigger-toggle').hide()
  }

  $( ".js-trigger-toggle" ).click(function() {
    $( ".js-cat-description" ).toggleClass('h-full');
    $( ".js-cat-description" ).toggleClass('h-24');
    $( ".js-cat-description-overlay" ).toggleClass('hidden');
    var x = document.getElementById("toggleText");
    if (x.innerHTML === "Lire plus") {
      x.innerHTML = "Lire moins";
    } else {
      x.innerHTML = "Lire plus";
    }
  });

  function isOverflown(element) {
    return element.prop('scrollHeight') > element.height();
  }
}
